exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".apc-react-body .user-history-date-range {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n  .apc-react-body .user-history-date-range > * {\n    -ms-flex-align: center;\n        align-items: center;\n    display: -ms-flexbox;\n    display: flex;\n    margin: 10px 0 10px 10px;\n    max-width: 200px; }\n  .apc-react-body .user-history-date-range .select-relative-time-operator {\n    min-width: 200px;\n    max-width: 200px; }\n", ""]);

// exports
